module.exports = __webpack_public_path__ + "h5/img/xiajiang.9d71bad1.png";